import React from "react";
import oxigenLogo from '../../assests/logo.png';
//import captcha from '../images/captcha.png';
import { ReCaptcha } from 'react-recaptcha-google'
import { loadReCaptcha } from 'react-recaptcha-google'
import { TextField } from '@material-ui/core';
import AuthService from '../../service/service-impl/AuthService';
import history from '../../auth/history';
import Axios from 'axios';
import { store } from "../../redux/store";
import { setRememberMe } from '../../redux/rememberMe/rememberMe.action';
import { connect } from "react-redux";

import { sha256 } from 'js-sha256';

import ErrorBoundary from './ErrorBoundary';
import apiCallService from "../../service/api-call-service";
import { setLocationData } from "../../redux/location/location.action";

class LoginComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            response: null,
            captchaDone: false,
            loginBtnDisable: false
        }
    }
    // getlocation = async () =>{

    //     var responseIp = await Axios.get('https://api.ipify.org?format=json')
    //     .then(async res => {
    //      const response = res.data;
    //       console.log(res.data);
    //       return response;
    //     });
  
    //   var payload = {
    //     ip: responseIp.ip
    //   }
    //   store.dispatch(setLocationData(payload));
    //   }

    componentDidMount() {
        // this.getlocation()
        if (this.captchaDemo) {
            console.log("started, just a second...")
            this.captchaDemo.reset();
        }

        loadReCaptcha();


        if (this.props.rememberMe) {
            this.setState({ email: this.props.rememberMail });
            this.setState({ password: this.props.rememberPassword });
        }


        // if (localStorage.getItem('errorMessage') === "Login is in process please wait") {
        //     localStorage.setItem('errorMessage', '');
        // }


        this.calalHashFunction();




    }

    calalHashFunction = async () => {


        var url = "https://payapi.zro.money:9001/bharatQRPay";

        var request = { "merchant_name": "paytmqr2810050501011hq7we9q99ej@paytm", "mobile_number": "9811960871", "qr_string": "upi://pay?pa=paytmqr2810050501011hq7we9q99ej@paytm&pn=Paytm%20Merchant&mc=5499&mode=02&orgid=000000&paytmqr=2810050501011HQ7WE9Q99EJ&sign=MEYCIQDfhG6A7BBlxjzFXDz0umcjwaV1znToySemuST1NCy4qwIhAPIVThah+SuxfyZKfrdjMKa6O5q8Wc1RZ6twmS5CfwgT", "tip_amount": 100, "transaction_amount": 100 }


        var response = await apiCallService.postMethodCall(url, request);

        console.log("Response from QR ", response);



    }



    onLoadRecaptcha = () => {
        if (this.captchaDemo) {
            this.captchaDemo.reset();
        }
        console.log('Testing-onLoadRecaptcha :' + this.state)
    }

    verifyCallback = (recaptchaToken) => {
        this.setState({ captchaDone: true });
        console.log(recaptchaToken, "<= your recaptcha token")
    }

    handleEmailChange = (event) => {
        this.setState({
            email: event.target.value
        })
        console.log('Testing-handleEmailChange :' + this.state)
    }

    handlePasswordChange = (event) => {
        this.setState({
            password: event.target.value
        })
        console.log('Testing-handlePasswordChange :' + this.state)
    }

    onChange = (event) => {
        this.setState({
            otp: event.target.value
        })
        console.log('Testing-handlePasswordChange :' + this.state.otp)
    }

    handleSubmit = (event) => {


        event.preventDefault();
        if (this.props.rememberMe) {
            localStorage.setItem('errorMessage', '')
        }
        console.log('inside initiateLogin successfully', event);

        var emailGG = this.state.email
        var passwordGG = this.state.password

        if (event.target[3] !== undefined) {
            var captchaValue = event.target[3].value;
        }

        console.log('inside initiateLogin successfully', username);
        var password = event.target[1].value;
        var datEncrypted = this.generateHash(password);
        console.log('inside initiateLogin successfully', captchaValue);
        if (process.env.REACT_APP_CAPTCHA_CONFIG !== '1') {
            if (captchaValue === 'false' || this.state.captchaDone === false) {
                return (localStorage.setItem('errorMessage', process.env.REACT_APP_CAPTCHA_NOT_CHECKED_MESSAGE),
                    this.setState({ email: emailGG })),
                    this.setState({ password: passwordGG })
                // history.push('/');
                // history.go();
            }
        }

        if (event.target[3] !== undefined) {
            event.target[3].innerText = 'Logging in...'
            event.target[3].className = 'logbtn-disable';
            event.target[3].disabled = true;
            console.log('inside initiateLogin successfully', password);
        }
        var username = event.target[0].value;



        localStorage.setItem('isbuttonDisabled', false);
        // event.refs.btn.setAttribute("disabled", "disabled");

        ////////////////////////////ACL-SERVICE-CALL////////////////////////////////////////////////////////
        this.setState({ loginBtnDisable: true });
        sessionStorage.removeItem('corplistpage')
        AuthService.apiCall(process.env.REACT_APP_LOGIN_URL, datEncrypted, username, this.props.rememberMe, 'OEMSAPP');
    }

    generateHash = (messageBody) => {
        //var msg= JSON.stringify(messageBody) ;
        var privateKey = '1234:aabbccdd';
        var hash = sha256.hmac.create(privateKey);
        hash.update(messageBody);
        var hexData = hash.hex();
        console.log('hexed data', hexData);
        var base64String = btoa(hexData);
        console.log(messageBody, '---->passowrd hash Generated --->', base64String);
        return base64String.replace(/[^a-zA-Z0-9]/g, "");
    }

    setRememberMe = (event) => {
        store.dispatch(setRememberMe(event.target.checked));
    }
    onBlurFunc = (e) => {
        var id = document.getElementById('password').readOnly = true;
    }
    onClickPassword = (e) => {
        var id = document.getElementById('password').readOnly = false;
    }


    handleChange = (e) => {
        e.preventDefault();
    };

    forgotPasswordClick = (e) => {

        if (this.state.loginBtnDisable) {
            // localStorage.setItem('errorMessage', 'Login is in process please wait')
        } else {
            history.push('/forgot-password');
            history.go();
        }


    }

    render() {
        return (

            <div className='col-12 col-md-6 col-lg-5 col-xl-4 frmbg'>
                <div className='login-form'>
                    <div className='logo'>
                        <img src={oxigenLogo} className='img-fluid' alt='ZRO' />
                    </div>
                    <h4>{process.env.REACT_APP_Var_FOR_LoginForm_Heading}</h4>
                    <p>{process.env.REACT_APP_Var_FOR_LoginForm_Paragraph}</p>

                    <form onSubmit={this.handleSubmit} autoComplete="off">
                        <div className='text-danger'>{localStorage.getItem('errorMessage')}</div>
                        {this.props.rememberMe ? null : localStorage.setItem('errorMessage', '')}
                        <div className='mdl-textfield mdl-js-textfield mdl-textfield--floating-label'>
                            <TextField required className='mdl-textfield' id='email' spellCheck="false" label={process.env.REACT_APP_Var_FOR_LoginForm_Email_Label} type='email' pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" value={this.state.email} onChange={this.handleEmailChange} />

                        </div><br />
                        <div className='mdl-textfield mdl-js-textfield mdl-textfield--floating-label'>
                            <TextField autoComplete="off" className='mdl-textfield abcd'

                                id='password'
                                label={process.env.REACT_APP_Var_FOR_LoginForm_Password_Label}
                                pattern="^([@#](?=[^aeiou]{7,13}$)(?=[[:alnum:]]{7,13}$)(?=.*[A-Z]{1,}.*$).+)$"
                                onClick={this.onClickPassword}
                                value={this.state.password} onChange={this.handlePasswordChange}
                                onBlur={this.onBlurFunc} readOnly={true} spellCheck="false"
                                onCut={this.handleChange}
                                onCopy={this.handleChange}
                                onPaste={this.handleChange} required />
                        </div>


                        <br />

                        <ErrorBoundary>
                            <ReCaptcha
                                id='captcha'
                                ref={(el) => { this.captchaDemo = el; }}
                                size="normal"
                                data-theme="light"
                                render="explicit"
                                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                onloadCallback={this.onLoadRecaptcha}
                                verifyCallback={this.verifyCallback}
                                isCaptured={this.state.captchaDone}
                                required
                            />
                        </ErrorBoundary>


                        <div className='form-row'>

                            <div className="col-12 col-sm-6">
                                <button className='logbtn' id="logBtn" type='submit' value={this.state.captchaDone} disabled={this.state.loginBtnDisable} >{process.env.REACT_APP_Var_FOR_LoginForm_Button_Label} </button>
                            </div>

                            <div className="col-12 col-sm-6">
                                <button type="button" onClick={this.forgotPasswordClick} className='float-right forgot' id="forgetId">{process.env.REACT_APP_Var_FOR_LoginForm_Link_ForgetPassword}</button>
                            </div>


                        </div>

                        {/* <div className='form-row'>
                            {/* <div className='col-6'>
                                <label className='mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect'>
                                    <input type='checkbox' id="remId" className='mdl-checkbox__input' checked={this.props.rememberMe} onClick={this.setRememberMe} />
                                    <span className='mdl-checkbox__label'>{process.env.REACT_APP_Var_FOR_LoginForm_CheckBox_RememberMe}</span>
                                </label>
                            </div> */}

                        {/* <div className='col-6'>
                                <a href='#' className='float-right forgot' id="forgetId">{process.env.REACT_APP_Var_FOR_LoginForm_Link_ForgetPassword}</a>
                            </div>
                        </div> */}

                    </form>
                </div>
            </div>

        )
    }

}


const mapStateToProps = ({ rememberMe: { rememberMe, rememberPassword, rememberMail } }) => ({
    rememberMe, rememberPassword, rememberMail
})

export default connect(mapStateToProps)(LoginComponent);